// extracted by mini-css-extract-plugin
export default {"footerDIV":"Footer_footerDIV__CXfdO","iconsDIV":"Footer_iconsDIV__pR-ib","contactame":"Footer_contactame__uWwKb","developedby":"Footer_developedby__vj1LP"};